import { SET_OBJECT_BOARDS } from './actionTypes';

export default (board, objectType) => ({
  type: SET_OBJECT_BOARDS,
  payload: {
    board,
    objectType
  }
});